<template>
  <div name="hrms15e-item" class="evaluation-item clearfix">
    <div class="col-xs-12 subject">
      {{ item.numitem }} {{ item.desc_numitem }}
    </div>
    <div class="col-xs-12 clear-padding">
      <div class="special">
        {{ labels['HRAP31EC4']['140'] }} {{ item.definit }}
      </div>
      <div v-for="choice in choices" class="choice">
        <div class="col-xs-12 clear-padding">
          <div class="col-xs-2 col-md-1 clear-padding">
            <input class="radio-size" type="radio" :disabled="disabled" :value="choice.grad" :id="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grad" v-model="item.graditem" />
            <label :for="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grditem" class="radio-label"></label>
          </div>
          <item-desc :dataGroup="dataGroup"
                     :item="item"
                     :choice="choice"
                     :labelsHrms15e="labelsHrms15e" />
        </div>
      </div>
    </div>
    <div class="col-xs-12 clear-padding ">
      <div class="col-xs-12 clear-padding">
        <div class="weight-box clearfix">
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> {{ labels['HRAP31EC4']['150'] }} : {{ parseFloat(item.targetscore).toFixed(2) }}</div>
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> {{ labels['HRAP31EC4']['170'] }} : {{ calQtyScore(item, choices) }}</div>
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star-half-o"></i> {{ labels['HRAP31EC4']['180'] }} : {{ calGap(item, choices) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemDesc from 'components/hrms15e/itemDesc2'

export default {
  name: 'hrms15e-item',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    },
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      default () {
        return []
      }
    },
    name: {
      type: String,
      required: true
    },
    labelsHrms15e: {
      type: Object
    }
  },
  methods: {
    calQtyScore (item, choices) {
      let choiceFiltered = choices.filter((choice) => {
        return choice.grad === item.graditem
      })
      let score = 0
      let grad = ''
      if (choiceFiltered.length > 0) {
        score = parseFloat(choiceFiltered[0].score)
        grad = choiceFiltered[0].grad
      }
      this.$set(item, 'score', score)
      this.$set(item, 'grad', grad)
      return score.toFixed(2)
    },
    calGap (item, choices) {
      let score = this.calQtyScore(item, choices)
      let targetScore = this.item.targetscore
      let gapscore = targetScore - score
      if (gapscore < 0) {
        gapscore = 0
      }
      this.$set(item, 'gapscore', gapscore)
      return gapscore.toFixed(2)
    }
  },
  components: {
    itemDesc
  }
}
</script>



// WEBPACK FOOTER //
// item2.vue?6e0fc5b0